export default "__VITE_ASSET__QXerH5mf__"